import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Desktop Sub Services - slide from right with fade
 */
export const animateSubServices = (ref, isMobile, selected) => {
  if (ref.current && !isMobile && selected && selected.services && selected.services.length > 0) {
    const element = ref.current;
    
    // Set initial state immediately to prevent flash
    gsap.set(element, { opacity: 0, x: 150 });
    
    const timer = setTimeout(() => {
      gsap.to(element, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: element,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });
      ScrollTrigger.refresh();
    }, 200);
    
    return () => clearTimeout(timer);
  }
};

